module.exports = __webpack_public_path__ + "static/media/ideologiq_background_mobile.95a5cf10.mov";